const release = '0.13.10'

module.exports = { release }



// WEBPACK FOOTER //
// ./release.js